import { useState } from "react";
import APP_CONFIG from "../../APP_CONFIG";
import { UserAvatar } from "../../components/Avatar";
import DataTable from "../../components/DataTable/DataTable";
import { Pagination } from "../../components/Pagination";
import { truncateString } from "../../utils/commonUtils";
import { getMediaPath } from "../../utils/mediaUtils";
import typography from "./typography";
import { SortOrder } from "../../constants";
import { findBarPercentage } from "./Utility";
import viewIcon from "../../assets/images/app/common/aou-view-icon.svg";
import { CustomModal } from "../../components/CustomModal";
import Details from "./Details";
import { RatingBarInput } from "../../components/RatingBarInput";
import CloseIcon from '../../assets/images/app/common/aou-close-icon.svg';
import { blsListing } from "../../api/api.service";
import { useLocalPaginatedRequest } from '../../hooks/useLocalPaginatedRequest';
import { convertDateTime, dateTimeFormat } from "../../utils/dateFormatUtils";
import { Tooltip } from "reactstrap";

const SORTABLE_COLUMNS = {
  [typography.CUSTOMER]: "customer",
  [typography.DATE]: "createdAt",
};

export default function BLSTable () {

  const [currentSortColumn, setCurrentSortColumn] = useState(null);
    const [currentSortOrder, setCurrentSortOrder] = useState(null);
    const [selectedFeedback, setSelectedFeedback] = useState(1)
    const [isModalActive, setIsModalActive] = useState(false)
    const {
        isFetching,
        page,
        total,
        data,
        refetch,
        handlePageClick,
        onChangePageSize,
        pageSize,
      } = useLocalPaginatedRequest(
        blsListing,
        {
          ...(currentSortColumn &&
            currentSortOrder && { column: currentSortColumn, direction: currentSortOrder }),
          ...({feedbackFormSubmitted: true})
        },
        [currentSortOrder]
        
      )
    
    const modalToggleHandler = (data) => {
        let tempData = {...data};
        tempData?.feedbackForm?.questions?.map(
            el => {
                let answerToQuestion = data?.userFeedbackFormAnswers?.filter(answer => answer?.questionId == el?.id);
                el.answerText = answerToQuestion[0]['answerText'];
            }
        );
        setSelectedFeedback(tempData)
        setIsModalActive(!isModalActive)
    }
    
    const handleSortClick = (item) => {
        setCurrentSortColumn(item.sortColumn);
        setCurrentSortOrder((prev) =>
            prev === SortOrder.ASC || !prev ? SortOrder.DESC : SortOrder.ASC
        );
    };

  return(
    <>
    <DataTable
    data={data}
    loading={isFetching}
    currentSortOrder={currentSortOrder}
    currentSortColumn={currentSortColumn}
    onSortClick={handleSortClick}
    config={[
        {
            sortColumn: SORTABLE_COLUMNS[typography.CUSTOMER],
            isSortable: false,
            title: typography.CUSTOMER,
            render: (data) => (
                <div className="d-flex align-items-center">
                    <UserAvatar
                        imgSrc={
                            data?.user?.profilePicture?.path ||
                            APP_CONFIG.IMAGES.AVATAR_PLACEHOLDER
                        }
                        altText={"avatar"}
                    />
                    <span className="ms-2 standard-typo-14-400">{truncateString(data?.user?.name, 30) || "-"}</span>

                </div>
            )
        },

        {
            sortColumn: SORTABLE_COLUMNS[typography.DATE],
            isSortable: true,
            title: typography.DATE,
            render: (data) => <div className="py-3 standard-typo-14-400">{convertDateTime({date: data?.createdAt,customFormat: dateTimeFormat.monthLetterFormat}) || "-"}</div>
        },

        {
            isSortable: false,
            title: typography.RATING,
            render: (data) => (
                <RatingBarInput
                rating={data?.rating}
                containerClass={"rating-bar-con"}
                innerClass={"rating-bar-inner"}
                 />
            )
        },{
            title: typography.AFFIRMATION_PHRASE,
            render: (data) => {
                return (
                    <div className="py-3 d-flex view-form-con" >
                        {/* <div className="standard-typo-14-400" id={data?.feedbackFormId}>{data?.affirmation?.affirmationPhrase || "-"}</div> */}
                       {data?.affirmation?.affirmationPhrase ? (
                        <div
                            className="move-to-top-icon-con me-3 standard-typo-14-400"
                            data-container={data?.affirmation?.affirmationPhrase}
                            
                        >
                           <div className="text-truncate-custom">{data?.affirmation?.affirmationPhrase}</div>
                        </div>
                       ): "-"} 
                    </div>
                );
            }
        },
        {
            title: typography.FEEDBACK_FORM,
            render: (data) => {
                return (
                    <div className="py-3 d-flex view-form-con" onClick={() => modalToggleHandler(data)}>
                        <div className="view-form-icon-con" >
                        <img
                            src={viewIcon}
                            alt={"view icon"}
                            role="button"
                        />
                        </div>
                        <span className="standard-typo-14-400">View Form</span>
                    </div>
                );
            }
        }
    ]} />
    <Pagination
        onPageClick={handlePageClick}
        currentPage={page}
        totalData={total}
        handleChange={(e) => onChangePageSize(e)}
        rowLimit={pageSize}
    />
    <CustomModal
    isOpen={isModalActive}
    onClose={() => setIsModalActive(!isModalActive)}
    size="xl"
    modalBodyClasses="pt-0"
    headerClass="p-0 pe-3 pt-2"
    closeIcon={CloseIcon}
    >
        <Details feedbackData={selectedFeedback} />
    </CustomModal>
    </>
  )
}